/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ topic: NonNullable<unknown> }} Coach_TopicInputs */

const en_us2_coach_topic = /** @type {(inputs: Coach_TopicInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`About: ${i?.topic}`)
};

const pt_br2_coach_topic = /** @type {(inputs: Coach_TopicInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sobre: ${i?.topic}`)
};

const es_419_coach_topic = /** @type {(inputs: Coach_TopicInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sobre: ${i?.topic}`)
};

const pt_pt2_coach_topic = /** @type {(inputs: Coach_TopicInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sobre: ${i?.topic}`)
};

const fr_fr2_coach_topic = /** @type {(inputs: Coach_TopicInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sujet : ${i?.topic}`)
};

const de_de2_coach_topic = /** @type {(inputs: Coach_TopicInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zu: ${i?.topic}`)
};

const it_it2_coach_topic = /** @type {(inputs: Coach_TopicInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Su: ${i?.topic}`)
};

/**
* | output |
* | --- |
* | "About: {topic}" |
*
* @param {Coach_TopicInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_topic = /** @type {((inputs: Coach_TopicInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_TopicInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_topic(inputs)
	if (locale === "es-419") return es_419_coach_topic(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_topic(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_topic(inputs)
	if (locale === "de-DE") return de_de2_coach_topic(inputs)
	if (locale === "it-IT") return it_it2_coach_topic(inputs)
	return en_us2_coach_topic(inputs)
});
export { coach_topic as "coach.topic" }